"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
var playkit_js_1 = require("@playkit-js/playkit-js");
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer() {
        var _this = _super.call(this) || this;
        _this.TIME_UPDATE_RATE = 250;
        _this._currentTime = 0;
        _this.playbackRate = 1;
        _this.duration = 0;
        return _this;
    }
    Timer.prototype.start = function (duration) {
        var _this = this;
        this.duration = duration;
        this.handleRestart();
        this.intervalID = setInterval(function () {
            _this._currentTime += _this.TIME_UPDATE_RATE / 1000;
            // @ts-ignore
            _this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.TIME_UPDATE));
            if (_this.isTimeUp())
                _this.onTimeIsUp();
        }, this.TIME_UPDATE_RATE / this.playbackRate);
    };
    Timer.prototype.end = function () {
        clearInterval(this.intervalID);
        this.intervalID = null;
    };
    Timer.prototype.handleRestart = function () {
        if (this.isTimeUp())
            this.reset();
    };
    Timer.prototype.seek = function (to) {
        this._currentTime = to;
    };
    Timer.prototype.speed = function (playbackRate) {
        this.playbackRate = playbackRate;
        if (this.intervalID) {
            this.end();
            this.start(this.duration);
        }
    };
    Object.defineProperty(Timer.prototype, "currentTime", {
        get: function () {
            return this._currentTime;
        },
        enumerable: false,
        configurable: true
    });
    Timer.prototype.isTimeUp = function () {
        return this._currentTime >= this.duration;
    };
    Timer.prototype.onTimeIsUp = function () {
        this.end();
        // @ts-ignore
        this.dispatchEvent(new playkit_js_1.FakeEvent(playkit_js_1.EventType.ENDED));
    };
    Timer.prototype.reset = function () {
        this.end();
        this._currentTime = 0;
    };
    return Timer;
}(playkit_js_1.FakeEventTarget));
exports.Timer = Timer;
